// extracted by mini-css-extract-plugin
module.exports = {"caption":"ComptabilitePrimes_caption__3Mk2N"};